import { takeLatest, put, call, select } from 'redux-saga/effects';
import { TRANSFER_USER_DATA_SAGA } from "../sagaTypes";
import { loaderAction, transferUserDataFormAction } from "../rootReducer";
import { url } from "../../config";
import growl from "../../lib/growl/growl";
import { setLocalStorage } from "../../helpers/LocalStorage";
import { TRANSFER_USER_DATA_FORM_INITIAL } from "../initialStateConstant";

const request = data => {
    return fetch(`${ url }/transfer_user_data`, {
        method: 'post',
        body: data
    })
        .then(response => response.json()).catch(error => console.log(error))
};

function* workerTransferUserData(args) {
    const user = yield select(state => state.user);

    yield put(loaderAction(true));
    try {
        let formData = new FormData();
        formData.append('user_id', user.id);
        formData.append('hash', user.hash);

        formData.append('wrongPhone', args.data.wrongPhone);
        formData.append('correctPhone', args.data.correctPhone);

        const response = yield call (request, formData);

        // Если не прошли проверку хеша разлогиниваемся
        if (response.void) {
            setLocalStorage('afp_fitness', '').then(() => window.location.reload());
        }

        if (response.success) {
            // Очищаем форму переноса данных и закрываем её
            yield put(transferUserDataFormAction(TRANSFER_USER_DATA_FORM_INITIAL));
            growl({ type: 'success', message: response.message });
        }
        else if (response.error) {
            growl({ type: 'error', message: response.message });
        }
    }
    catch(error) {
        console.log(error);
        yield put(loaderAction(false));
    }
    finally {
        yield put(loaderAction(false));
    }
}

export default function* watcherTransferUserData() {
    yield takeLatest(TRANSFER_USER_DATA_SAGA, workerTransferUserData);
}